import { createAction } from '@reduxjs/toolkit';
const prefix = `elevio/resolution`;
export const resolutionActions = {
    ticketResolved: createAction(`${prefix}/ticketResolved`),
    initiateResolutionPrompt: createAction(`${prefix}/initiateResolutionPrompt`),
    setSolution: createAction(`${prefix}/setSolution`),
    setSolutionDropdownOpen: createAction(`${prefix}/setSolutionDropdownOpen`),
    setSolutionDropdownClosed: createAction(`${prefix}/setSolutionDropdownClosed`),
    debouncedSetSolutionDropdownClosed: createAction(
    // debounced to prevent rapid closing of dropdown, see Saga notes for details
    `${prefix}/debouncedSetSolutionDropdownClosed`),
    setSolutionSubmitted: createAction(`${prefix}/setSolutionSubmitted`),
    // Cancellation flow
    setCancelWarning: createAction(`${prefix}/setCancelWarning`),
    unsetCancelWarning: createAction(`${prefix}/unsetCancelWarning`),
    setNoSolution: createAction(`${prefix}/setNoSolution`),
    setNoSolutionNoDraftArticle: createAction(`${prefix}/setNoSolutionNoDraftArticle`),
    setNoSolutionSubmitted: createAction(`${prefix}/setNoSolutionSubmitted`),
    setNoSolutionDraftArticle: createAction(`${prefix}/setNoSolutionDraftArticle`),
    setNoSolutionDraftArticleSubmitted: createAction(`${prefix}/setNoSolutionDraftArticleSubmitted`),
    setResolutionArticleId: createAction(`${prefix}/setResolutionArticleId`),
    unsetResolutionArticleId: createAction(`${prefix}/unsetResolutionArticleId`),
    setResolutionDraftQuestion: createAction(`${prefix}/setResolutionDraftQuestion`),
    setResolutionDraftNotes: createAction(`${prefix}/setResolutionDraftNotes`),
    setResolutionArticleIds: createAction(`${prefix}/setResolutionArticleIds`),
    setResolutionInputValue: createAction(`${prefix}/setResolutionInputValue`),
    setResolutionSearchTerm: createAction(`${prefix}/setResolutionSearchTerm`),
    setResolutionArticleContent: createAction(`${prefix}/setResolutionArticleContent`),
    // Exited resolution flow early
    ticketResolutionExited: createAction(`${prefix}/ticketResolutionExited`),
};
